export class TourAttractionFormView {

    private _id: number;
    private _name: string;
    private _nameMain: string;

    constructor(
      id: number,
      name: string,
      nameMain: string,
    ) {

        this._id = id;
        this._name = name;
        this._nameMain = nameMain;

    }


    get id(): number {
        return this._id;
    }

    get name(): string {
        return this._name;
    }

    get nameMain(): string {
        return this._nameMain;
    }

}